import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Confirm } from 'semantic-ui-react';
import { connect } from 'react-redux';

import { closeAllModals } from '../../../data/fileImport/modalActions';

class ProcessDataComfirmModal extends Component {
  /**
   * cancel process data
   */
  handelProcessDataCancel() {
    this.props.dispatch(closeAllModals());
  }

  /**
   * Confirm process data
   */
  handelProcessDataConfirm() {
    this.props.dispatch(closeAllModals());
  }

  render() {
    return (
      <Confirm
        className="confirmModalProcessData"
        key={2}
        open={this.props.isOpen}
        cancelButton="Cancel processing"
        confirmButton="OK"
        content={`Warning \n  Are you sure you want to process ${
          this.props.processDataModal.dataQty === 'all' ? 'all data' : 'this column'
        }?`}
        onCancel={this.handelProcessDataCancel}
        onConfirm={this.handelProcessDataConfirm}
      />
    );
  }
}

ProcessDataComfirmModal.propTypes = {
  isOpen: PropTypes.bool // eslint-disable-line react/require-default-props
};

export default connect(state => ({
  sessions: state.projects.single.fileImport.sessions,
  processDataModal: state.projects.single.fileImport.modals.confirmProcessData
}))(ProcessDataComfirmModal);



// WEBPACK FOOTER //
// ./src/scenes/projects/scenes/singleProject/components/fileImport/modals/ProcessDataComfirmModal.js